import { imageAll } from './ImageStore';

export const updateImageAll = (value) => imageAll.update((oldValue) => value);
